import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { GenderData } from "./action";
import Home from "./component/Home";
import Login from './component/Login';
import Reg from './component/reg/Reg';
import BusinessReg from './component/BusinessReg';
// import Cart from './component/Cart';
import ProductDetails from "./component/ProductDetails";
import Products from './pages/Products/Products';
import Search from './pages/Products/Search';
import BannerProducts from './pages/Products/BannerProducts';
import Landing from './component/Landing';
import Cart from './pages/Cart/Cartpage';
import Checkout from './pages/Checkout/Checkout';
import OrderSuccess from './pages/Cart/OrderSuccess';
import OrderFailed from './pages/Cart/OrderFailed';
import "./App.css";
import Wishlist from './component/Wishlist';
import Faq from './pages/Faq';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Delivery from './pages/Delivery';
import Returns from './pages/Returns';
import Partner from './pages/Partner';
import ResetPassword from './pages/resetpassword/ResetPassword';
import AppAuth from './pages/AppAuth';

import Profile from './component/Profile';
import SearchData from './component/SearchData';
import Yeah from "./Yeah"

import "./index.css"
import ZoomImage from './pages/resetpassword/zoomImage';
import Brand from './pages/Brands/Brand';
import ProtectedLayout from './Layout/ProtectedLayout';
import Paynow from './pages/Checkout/Payments/Paynow';
import PaymentResult from './pages/Checkout/Payments/PaymentResult';
import Trypay from './pages/Checkout/Payments/Trypay';
import Brandspage from './pages/Brands/Brandspage';
import { applyConsent, getCookieConsent, subscribeToConsentChanges } from './helper/analyticsConsent';
import GenderHomeRoute from "./component/GenderHomeRoute";
import AppAuthRedirect from "./component/AppAuthRedirect";
import BackToTop from "./component/Common/BackToTop";
import AlbiCartNotice from "./component/Common/AlbiCartNotice";


export default function App() {
    //const navigate = useNavigate();
    const genderData = useSelector(state => state?.category?.gender);
    const dispatch = useDispatch();
    const RemoveGender = async () => {
        const gender = null;
        await dispatch(GenderData(gender))
    }

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            RemoveGender();
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        // Apply consent on app load and react to consent updates from the cookie banner.
        applyConsent(getCookieConsent());
        const unsubscribe = subscribeToConsentChanges((consent) => {
            applyConsent(consent);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    return (
        <div>
            <AppAuthRedirect />
            <Routes>
                <Route path="/auth/app" element={<AppAuth />}></Route>
                <Route path="/home" element={<Home />}></Route>
                <Route path="/female" element={<GenderHomeRoute gender="female" />} />
                <Route path="/male" element={<GenderHomeRoute gender="male" />} />
                <Route path="/kids" element={<GenderHomeRoute gender="kids" />} />
                <Route path="/life" element={<GenderHomeRoute gender="life" />} />
                <Route path="/login" element={<Login />}></Route>
                <Route path="/signup" element={<Reg />}></Route>
                <Route path="/business" element={<BusinessReg />}></Route>
                <Route path="/cart" element={<Cart />}></Route>
                <Route path="/productdetails/:id/:catId" element={<ProductDetails />}></Route>
                <Route path="/products" element={<Products />}></Route>
                <Route
                    path="/profile"
                    element={
                        <ProtectedLayout>
                            <Profile />
                        </ProtectedLayout>
                    }
                />
                <Route
                    path="/profile/:section"
                    element={
                        <ProtectedLayout>
                            <Profile />
                        </ProtectedLayout>
                    }
                />
                <Route path="/:id/:catId" element={<Products />}></Route>
                <Route path="/" element={<Landing />}></Route>
                <Route path="/order-success" element={<OrderSuccess />}></Route>
                <Route path="/order-failed" element={<OrderFailed />}></Route>
                <Route path="/wishlist" element={<Wishlist />}></Route>
                <Route path="/faq" element={<Faq />}></Route>
                <Route path="/contact-us" element={<Contact />}></Route>
                <Route path="/privacy" element={<Privacy />}></Route>
                <Route path="/terms-conditions" element={<Terms />}></Route>
                <Route path="/delivery" element={<Delivery />}></Route>
                <Route path="/returns" element={<Returns />}></Route>
                <Route path="/our-partners" element={<Partner />}></Route>
                <Route path="/brands/:name" element={<BannerProducts />}></Route>
                <Route path="/brands" element={<Brandspage />}></Route>
                <Route path="/brand/:name" element={<Brand />}></Route>
                <Route path="/search/:vendorName?" element={<Search />}></Route>
                <Route path="/new-arrivals" element={<Search />}></Route>
                <Route path="/top-picks" element={<Search />}></Route>
                <Route path="/resetpassword" element={<ResetPassword />}></Route>
                <Route path="/reset-password" element={<ResetPassword />}></Route>
                <Route path="/zoomimage" element={<ZoomImage />}></Route>

                <Route path="/checkout" element={<Checkout />} />

                <Route path="/pay" element={<Paynow />} />

                <Route
                    path="/trypay"
                    element={
                        <ProtectedLayout>
                            <Trypay />
                        </ProtectedLayout>
                    }
                />

                <Route
                    path="/payment/result"
                    element={
                        <ProtectedLayout>
                            <PaymentResult />
                        </ProtectedLayout>
                    }
                />


            </Routes>
            <BackToTop />
            <AlbiCartNotice />
        </div>
    )
}

// trigger deploy boxes